/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Gautham Prakash",
  title: "Hey there, I'm Gautham",
  subTitle: emoji(
    "A mixed bag tech lover 🚀 capable of building and fixing"
  ),
  resumeLink:
    "https://github.com/gauthamp10/gauthamp10/blob/main/resume.pdf",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/gauthamp10",
  linkedin: "https://www.linkedin.com/in/gautham-prakash-207442126/",
  gmail: "gauthamp10@gmail.com",
  gitlab: "https://gitlab.com/gauthamp10",
  facebook: "https://www.facebook.com/gautham.prakash1",
  medium: "https://medium.com/@gauthamp10",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "My stack",
  skills: [
    emoji(
      "⚡ Software Development"
    ),
    emoji("⚡ Presentation"),
    emoji(
      "⚡ Freelancing"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Marian College Kuttikanam",
      logo: require("./assets/images/marian.png"),
      subHeader: "Master of Computer Applications",
      duration: "July 2018 - March 2020",
      //desc: "Participated in the research of XXX and published 3 papers.",
      //descBullets: [
      //  "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //  "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      //]
    },
    {
      schoolName: "St. Berchmans College",
      logo: require("./assets/images/sb.jpg"),
      subHeader: "Bachelor of Computer Applications",
      duration: "June 2015 - March 2018",
      //desc:
      //  "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      //descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
//  viewSkillBars: true, //Set it to true to show Proficiency Section
//  experience: [
//    {
//      Stack: "Frontend/Design", //Insert stack or technology you have experience in
//      progressPercentage: "90%" //Insert relative proficiency in percentage
//    },
//    {
//      Stack: "Backend",
//      progressPercentage: "70%"
//    },
//    {
//      Stack: "Programming",
//      progressPercentage: "60%"
//   }
//  ],
//  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Freelance Backend Developer",
      company: "UBC Sauder School of Business",
      companylogo: require("./assets/images/ubc.jpg"),
      date: "June 2019 – July 2019",
      desc:
        "Worked on Google Playstore Review data collection",
     // descBullets: [
     //  "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
     //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
     // ]
    },
    {
      role: "Freelance Backend Developer",
      company: "The Chinese University of Hong Kong",
      companylogo: require("./assets/images/cuhk.jpg"),
      date: "July 2020 – Dec 2020",
      desc:
        "App data collection from Huwaei AppGallery, Apple AppStore and Tencent MyApp"
    },
    {
      role: "Intern",
      company: "entinker",
      companylogo: require("./assets/images/entinker.png"),
      date: "May 2019 – June 2019",
      desc:
        "Learn fundamentals of project mangement and worked on organisation project"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "gauthamp10", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Some useful projects",
  projects: [
    {
      image: require("./assets/images/gplaydataset.png"),
      projectName: "Google Playstore Dataset",
      projectDesc: "App Dataset of 1.2 million playstore application",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.kaggle.com/gauthamp10/google-playstore-apps"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/dockerforall.png"),
      projectName: "Dockerfile Boilerplate for all",
      projectDesc: "Docker boilerplates / templates for most common progamming languages. Like a Hello World! but for docker images.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/gauthamp10/dockerfile-boilerplates"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Best Outgoing Student (2018 - 2020)",
      subtitle:
        "Won the Best Outgoing Student Award from Marian College Kuttikkanam.",
      image: require("./assets/images/outgoing.ico"),
      footerLink: [
        {
          name: "Award",
          url:
            ""
        },
      ]
    },
    {
      title: "IT QUIZ (2016 - 2019)",
      subtitle:
        "16 times winner of Information Technology Quiz competitions conducted in various institutions all over South India",
      image: require("./assets/images/qui.png"),
      footerLink: [
        {
          name: "View Certificates",
          url:
            ""
        }
      ]
    },

    {
      title: "The Python MEGA Course",
      subtitle: "Completed Certifcation from Udemy",
      image: require("./assets/images/python.png"),
      footerLink: [
        {name: "Certification", url: ""},
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Like to scribble things down sometimes...",

  blogs: [
    {
      url:
        "https://dev.to/gauthamp10/easiest-way-to-install-android-os-via-linux-no-grub-fiddling-3gao",
      title: "Easiest way to install Android OS via Linux. No Grub fiddling!",
      description:
        "Dual boot android x86 without hassle...."
    },
    {
      url: "https://dev.to/gauthamp10/reasons-why-i-switched-to-linux-full-time-30ek",
      title: "8 reasons why I switched to Linux Fulltime!",
      description:
        "The reason why I wrote this blog is to let you all get a glimpse of why using a free and open source operating system is always better for people in the tech domain..."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
//  title: "TALKS",
//  subtitle: emoji(
//    ""
//  ),

//  talks: [
//    {
//      title: "",
//      subtitle: "",
//      slides_url: "",
//      event_url: ""
//    }
//  ],
//  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
//  title: emoji("Podcast 🎙️"),
//  subtitle: "",

  // Please Provide with Your Podcast embeded Link
//  podcast: [
//    "some-podcast-url"
//  ],
 // display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "gauthamp10@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "Gauthamprakash1", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
